import { useState, useEffect } from "react";
import { Col, Row, Grid } from "antd";
import { MyText } from "../../../common";
import { WaveContainer } from "../WaveContainer";
import { EmblaOptionsType } from "embla-carousel";
import EmblaCarousel from "./Carousel";
import {useTranslation} from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviewsListAction } from "../../../../utils";

const isMobile = window.innerWidth < 768;

const OPTIONS: EmblaOptionsType = { dragFree: true, loop: true };

export const Section8 = () => {
  // const [reviews, setReviews] = useState([]);
  // const [loading, setLoading] = useState(true);
  const {t, i18n} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const dispatch = useDispatch();
  const reviewsList = useSelector((state: any) => state.profile.reviewsList);

  const reviews = reviewsList.data || [];
  const loading = reviewsList.loading;

  useEffect(() => {
    dispatch(fetchReviewsListAction({}));
  }, []);

  const data = (Array.isArray(reviews) ? reviews : []).map(review => ({
    comment: review.review_text,
    author: review.name,
  }));

  return (
    <WaveContainer
      containerStyle={{
        backgroundColor: '#FCF8F1',
        paddingBottom: screens.xs ? 0 : 47
      }}>
      <Row gutter={[24, 24]}>
        <Col span={24} style={{ textAlign: 'center' , marginBottom: screens.xs ? 0 : '32px'}}>
          <MyText color='#0A033C' size={screens.xs || isTablet ? 28 : 48} weight={800} style={{ fontFamily: 'Nunito', textAlign: 'center' }}>
            {t("userFeedback")}
          </MyText>
        </Col>

        {data.length > 0 && (
          <Col span={24} style={screens.xs ? { height: screens.xs ? 'auto' : '260px' } : {}}>
            <EmblaCarousel slides={data} options={OPTIONS} />
          </Col>
        )}
      </Row>
    </WaveContainer>
  );
}
